// import axios from 'axios'
import requests from '../utils/request'

// 我的产品
export const getproductslist = (data)=>{
    return requests({
        url:'/buyer/my/products/page/list',
        method:'post',
        data
    }) 
}

// 上下架
export const IsSelling =(data)=>{
    return  requests({
        url:'/buyer/my/products/selling/update',
        method:'post',
        data
    })
}
// 删除
export const delporduct = (data)=>{
    return  requests({
        url:'/buyer/my/products/delete',
        method:'post',
        data
    })
}
// 模板导入
export const importExcel = (data)=>{
    return  requests({
        url:'/buyer/my/importFile',
        method:'post',
        headers: {
            'Content-Type': 'multipart/form-data'
         },
        data
    })
}

// 查询导入状态 /buyer/my/import/list
export const importstate = (id)=>{
    return  requests({
        url:'/buyer/my/import/list?id='+id,
        method:'get'
    })
}